import { InjectionToken, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';

/*
Tokeny przydaja sie podczas osadzania formularza logowania w uploaderze, wtedy referer oraz typ baneru bedzie mozna przekazac przez DI
Zamiast bezpośrednio ifowac logike w komponencie. Takie podejscie pozwala rowniez na latwiejsze testowanie komponentu
*/

export const refererFactory = () => {
  const activatedRoute = inject(ActivatedRoute);
  const document = inject(DOCUMENT);

  if (activatedRoute.snapshot.queryParamMap.has('referer')) {
    const referer = activatedRoute.snapshot.queryParamMap.get('referer');

    if (referer) {
      return referer;
    }

    return;
  }

  const isFromThisApplication = document.referrer && document.referrer.includes(`${document.location.origin}/account`);

  if (document.referrer && !isFromThisApplication) {
    return document.referrer;
  }

  return undefined;
};

export const REFERER = new InjectionToken<string | undefined>('REFERER', {
  factory: refererFactory,
});

export type BannerType = 'default' | 'features';

export const BANNER_TYPE = new InjectionToken<BannerType>('BANNER_TYPE', {
  factory: () => {
    const activatedRoute = inject(ActivatedRoute);

    if (activatedRoute.snapshot.queryParams['flow_type'] === 'orderProcess') {
      return 'features';
    }

    return 'default';
  },
});
